import AccountProvider from "components/common/Context/AccountContext"
import { allIncidentStates } from "constants/Constants"
import { getIncidentDetails } from "extensions/usoc/api/service"
import { getIncidentDetailWithPage } from "extensions/usoc/api/service"
import { useContext, useMemo } from "react"
import { useSelector } from "react-redux"
import useSWR from "swr"
import { getDateParams, splitDateRange } from "utils/date"
import { isAnyAPIFailed } from "utils/nodata"
import { batchAPICalls, retryFailedRequests } from "utils/retryFailedRequests"

import useExtension from "./useExtension"
import useUserAuth from "./useUserAuth"


// async function fetchIncidentDetails(auth, extension, projectId, params) {
//   const host = extension?.config?.env?.clientApiGateway?.URL
//   const results = []
//   for (const param of params) {
//     const result = await retryFailedRequests({ auth, host }, projectId, param, getIncidentDetails)
//     results.push(result)
//   }
//   return results
// }

export default function ({
  dateRangeFilter,
  condition = true,
  stateFilter = allIncidentStates
}) {
  const auth = useUserAuth()
  const extension = useExtension()

  const projectID = useSelector((state) => {
    return state.settings.currentProject
  })

  const { selectedAccounts: accounts } = useContext(AccountProvider)

  const selectedAccounts = useMemo(() => {
    const accountIds = []
    // const accountNames = []
    accounts.forEach((account) => {
      if (account.account_number === "EMPTY") accountIds.push("")
      // else if (account.account_number.search(gcpAccountIdRegex) >= 0)
      //   accountNames.push(account.account_number)
      else accountIds.push(account.account_number)
    })
    return { accountIds }
  }, [accounts])

  const dateRangeFilters = useMemo(() => {
    return Array.isArray(dateRangeFilter) ? dateRangeFilter : [dateRangeFilter]
  }, [dateRangeFilter])

  const dateRangeSegmentsArray = useMemo(() => {
    return dateRangeFilters.map((dateRangeFilter) =>
      splitDateRange(dateRangeFilter)
    )
  }, [dateRangeFilters])

  const incidentParams = useMemo(() => {
    return dateRangeSegmentsArray
      .map((dateRangeSegments) =>
        dateRangeSegments.map(
          (dateRangeSegment) =>
            `state=${stateFilter || allIncidentStates}&${getDateParams(
              dateRangeSegment
            )}`
        )
      )
      .flat()
  }, [dateRangeSegmentsArray, stateFilter])

  const { data: incidentResponses } = useSWR(
    () =>
      projectID && condition
        ? incidentParams.map(
          (param) => `/projects/${projectID}/get_incident_details?${param}`
        )
        : null,
    () => batchAPICalls(auth, extension, projectID, incidentParams, getIncidentDetailWithPage,true),
    { suspense: true }
  )

  const accountFilteredIncidentDetails = useMemo(() => {
    let i = 0
    return dateRangeSegmentsArray.map((dateRangeSegments) => {
      const slicedIncidentDetails =
        incidentResponses?.slice(i, i + dateRangeSegments.length) || []
      i += dateRangeSegments.length
      return {
        data: slicedIncidentDetails
          ?.map((eachResponse) =>
            Array.isArray(eachResponse?.data)
              ? eachResponse?.data.filter(
                (eachData) =>
                  selectedAccounts.accountIds.includes(eachData.account_id)
                // ||
                // selectedAccounts.accountNames.includes(
                //   eachData.account_name
                // )
              )
              : []
          )
          .flat(),
        error: isAnyAPIFailed(slicedIncidentDetails)
      }
    })
  }, [
    incidentResponses,
    dateRangeSegmentsArray,
    selectedAccounts.accountIds
  ])

  return Array.isArray(dateRangeFilter)
    ? accountFilteredIncidentDetails
    : accountFilteredIncidentDetails[0]
}
